import { render, staticRenderFns } from "./studyPublish.vue?vue&type=template&id=79474261&scoped=true"
import script from "./studyPublish.vue?vue&type=script&lang=js"
export * from "./studyPublish.vue?vue&type=script&lang=js"
import style0 from "./studyPublish.vue?vue&type=style&index=0&id=79474261&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79474261",
  null
  
)

export default component.exports